// extracted by mini-css-extract-plugin
export var dropdown = "_od-1";
export var hidden = "_od-0";